

<template>
    <div class="expenseSetting">
      <div class="content-container">
        <div class="titieMian">
          <div class="title-container">费用设置</div>
          <div class="select-container">
            <div class="classify"><span>当前类目 :</span><span>{{$route.query.name}}</span></div>
            
            <div class="select-container-box">
              <el-input
                placeholder="请输入费用名称"
                v-model="name"
                :maxlength="num"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                size="small"
                class="search-input"
                clearable>
              </el-input>
            </div>
            <div class="select-container-box">
              <el-button size="small"  type="info" plain @click="search()" class="query">查询</el-button>
              <el-button size="small"  type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
              <span  @click="back" class="back" >返回上级</span>
            </div> 
            
          </div>
        </div>  
        <div class="table-container">
          <el-table
            :row-class-name="rowClassName"
            :data="expenseNameList"
            style="width:100%"
            size="medium"
            >
            <el-table-column
              prop="name"
              label="费用名称"
              align="center"
              show-overflow-tooltip
             >
            <template slot-scope="scope">
                <el-input v-model="scope.row.name" maxlength="20" placeholder=""></el-input>
            </template>
            </el-table-column>
             <el-table-column
            prop="createDate"
            label="创建时间"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
            <el-table-column label="操作" align="center" >
              <template slot-scope="scope" >
                <span
                  class="content-edit"
                  v-if="scope.row.allow===true"
                  @click="handleEdit(scope.$index, scope.row)">{{edit?scope.row.edit:'查看'}}</span>
                <span
                  class="content-del"
                  v-if="scope.row.allow===true&&edit"
                  @click="handleDelete(scope.$index, scope.row)" >删除</span>
                <span v-if="scope.row.allow===false" style="color:#666">默认不可修改</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import { MessageBox, Message } from "element-ui";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "detail",
  mixins: [mixins],
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      num: 20,
      rowId: "",
      name: "",
      once: true,
      expenseNameList: []
    };
  },
  methods: {
    ...mapActions(modules.expense, {
      getExpenseName: "getExpenseName", //获取所有费用名称
      addExpenseName: "addExpenseName", //添加费用名称
      updateExpenseName: "updateExpenseName", //修改
      editExpenseName: "editExpenseName", //编辑数据
      delExpenseName: "delExpenseName" //删除
    }),
    ...mapActions(['delVisitedViews']),
    // 动态设置行的类名
    rowClassName(row) {
      if (row.row.edit == "编辑") {
        return "";
      } else {
        return "row-disabled";
      }
    },
    //查询数据
    search() {
      let obj = {
        name: this.name, //费用名称
        pid: this.id
      };
      this.getExpenseName(obj)
        .then(rsp => {
          this.expenseNameList = this.filterdata(rsp);
        })
        .catch(err => {
          Message.error(err.response.data);
        });
    },
    filterdata(arr) {
      return arr.map(item => {
        item.edit = "编辑";
        item.createDate = this.$timeformat(item.createDate);
        console.log(item.time);
        return item;
      });
    },
    // 返回上级
    back() {
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.push({
        name: "expenseSetting"
      });
    },
    //添加
    async add() {
      if (this.once) {
        this.expenseNameList.unshift({
          allow: true,
          id: "",
          createDate: this.$timeformat(new Date()),
          name: "",
          edit: "保存"
        });
        this.once = false;
      } else {
        this.$Alert.info({
          content: "每次只能添加一条记录，请先保存",
          duration: 5000,
          status: "error"
        });
        // Message.error("每次只能添加一条记录，请先保存");
      }
    },
    //获取编辑添加数据
    async handleEdit(index, row) {
      switch (row.edit) {
        case "保存":
          if (row.name == name) {
            this.$message({
              message: "费用名称不能为空",
              type: "error"
            });
            return;
          }
          if (!row.id) {
            this.addExpenseName({
              name: row.name,
              time: row.time,
              pid: this.id,
              type: this.type,
              versionType: 1
            })
              .then(rsp => {
                console.log("添加");
                if (rsp.status === 200) {
                  this.$message({
                    message: "添加成功",
                    type: "success"
                  });
                  this.search();
                  this.expenseNameList[index].edit = "编辑";
                  this.once = true;
                }
              })
              .catch(err => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error"
                });
                // this.$message.error(err.response.data);
              });
          } else {
            console.log("编辑");
            if (row.name == name) {
              this.$message({
                message: "费用名称不能为空",
                type: "error"
              });
              return;
            }
            this.updateExpenseName({
              id: row.id,
              name: row.name,
              type: this.type,
            })
              .then(() => {
                // this.search();
                this.expenseNameList[index].edit = "编辑";
              })
              .catch(err => {
                this.$Alert.info({
                  content: err.response,
                  duration: 5000,
                  status: "error"
                });
              });
          }
          break;
        case "编辑":
          this.expenseNameList[index].edit = "保存";
          break;
      }
    },
    //删除
    handleDelete(index, row) {
      if (!row.id) {
        this.expenseNameList.shift();
        this.once = true;
        return;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.rowId = row.id;
          await this.delExpenseName(this.rowId);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.search();
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    }
  },

  async mounted() {
    console.log(this.curCompany.isQlwVersion);
    this.search(); //查询
  },
  
  //监听参数的变化，如监听路由中id值的变化：
  watch:{
    '$route.query.id': {
      handler(newVal,oldVal){
        console.log(23333333, this.$route);
        if(this.$route.path !== '/expense/expenseSetting/detail') return
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        //判断newVal有没有值监听路由变化
        this.search()
      },
      deep: true
    }
  }
};
</script>
<style lang="stylus">
.expenseSetting
  .back
    color:white !important;
    width: 80px;
    height: 34px;
    line-height:34px;
    box-sizing:border-box;
    font-size: 14px !important;
    margin-right: 6px;
    margin-left:10px;
    border-radius:5px;
    cursor: pointer;
    background:#f76257;
  .classify
    margin-left:20px;
    font-size:16px;
    color:#666;
    span
      margin-right:10px;
  .el-table tr:hover>td 
    background:none !important;
  .el-table 
    .el-input,input
      pointer-events:none
      text-align:center;
      background: none;
      .el-input__inner
        border:none
  
  // 添加 row-disabled
  .el-table 
    .row-disabled
      .el-icon-arrow-up:before
        content: "\E605";
      td,.el-input,input
        pointer-events:auto
      .el-input__inner
        border:1px solid #ddd;
      .el-input--suffix
        .el-input__inner
          border:1px solid #ddd;
          padding-right:30px;
          padding-left:10px;
</style>
